import React, { useEffect, useRef, useState } from "react";
import { Radio } from "@aqar-app/react-ui";
import {
  getDynamicLabel,
  useRevalidateAndCalculations,
} from "@/components/add-v2/validate";
import { dispatchCtxChange } from "@/components/add-v2/ui";
import css from "./.module.scss";

export function RadioComponent({
  value: initialValue,
  defaultValue,
  rules,
  label,
  dynamic,
  name,
  ctxRef,
  options,
  button,
  dependencies,
  onChange,
  nested,
  calculations,
  visibilityRules,
  dynamicProps: dp,
  ...props
} = {}) {
  const ctx = ctxRef.current;
  const [value, setValue] = useState(initialValue || defaultValue);
  const [error, setError] = useState(null);
  const text = label?.dynamic ? getDynamicLabel({ label, ctx }) : label?.ar;
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    root.addEventListener("validate", (e) => {
      setError(e?.detail?.error);
    });
  }, []);
  return (
    <div
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
      }}
      ref={rootRef}
    >
      <p>{text || name}</p>
      <Radio
        hasError={error}
        value={value}
        onChange={(e, raw) => {
          setError(null);
          setValue(e.target.value);
          dispatchCtxChange(rootRef.current, {
            value: raw,
            nested,
            name,
          });
        }}
        button={button}
        name={name}
        {...props}
      >
        {options &&
          typeof options?.map === "function" &&
          options.map((option) => (
            <Radio.Option
              key={option.value}
              raw={option.value}
              label={option.label?.ar || option.label}
              value={option.value}
            />
          ))}
      </Radio>
      <p className={css.error}>{error}</p>
    </div>
  );
}
